export default __webpack_public_path__ + "static/media/dr-sum.8b1743f8.jpg";